import {createContext} from 'react'

export const AuthContext = createContext()
export const UserContext = createContext()
export const DemoDataContext = createContext()
export const ServiceWorkerContext = createContext()
export const CurrentTaleContext = createContext([null, true])
export const AudioContext = createContext()
